<app-nav
    [titulo]="editMode ? 'Editar comercial' : 'Nuevo comercial'"
    [descripcion]="editMode ? 'Modificá los datos del comercial y guardá los cambios.' : 'Buscá un usuario por email y completá los datos del comercial.'">
    <div class="edit-comercial basic-avm-editor">
        <div class="form-stepper">
            <form [formGroup]="form" class="form-step">

                <h3 class="form-step-title">{{ editMode ? 'Editar comercial' : 'Nuevo comercial' }}</h3>

                <ng-container *ngIf="!editMode">
                    <span class="form-step-description">Buscá el usuario al que vincularás este comercial por su email de acceso a la plataforma.</span>

                    <div class="user-search-row">
                        <mat-form-field class="garantor-form-field search-field" appearance="outline">
                            <mat-label>Email del usuario</mat-label>
                            <input matInput [formControl]="emailBusqueda" placeholder="Ej: agente@remax.com" (keyup.enter)="buscarUsuario()">
                            <mat-error *ngIf="emailBusqueda.hasError('required')">El email es requerido</mat-error>
                            <mat-error *ngIf="emailBusqueda.hasError('email')">Ingresá un email válido</mat-error>
                        </mat-form-field>
                        <button mat-raised-button type="button" class="garantor-button search-button" color="primary" (click)="buscarUsuario()" [disabled]="buscandoUsuario">
                            Buscar
                        </button>
                    </div>

                    <div class="user-found-card" *ngIf="usuarioEncontrado">
                        <mat-icon color="primary">check_circle</mat-icon>
                        <div class="user-found-info">
                            <span class="user-found-name">{{ usuarioEncontrado.nombre }}</span>
                            <span class="user-found-email">{{ usuarioEncontrado.email }}</span>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="editMode">
                    <span class="form-step-description">Modificá los datos del comercial. El usuario vinculado no puede cambiarse.</span>

                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Email del usuario vinculado</mat-label>
                        <input matInput [value]="comercial?.email ?? ''" disabled>
                    </mat-form-field>
                </ng-container>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="nombre">
                    <mat-error *ngIf="form.controls['nombre'].hasError('required')">El nombre es requerido</mat-error>
                </mat-form-field>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Apellido</mat-label>
                    <input matInput formControlName="apellido">
                    <mat-error *ngIf="form.controls['apellido'].hasError('required')">El apellido es requerido</mat-error>
                </mat-form-field>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Teléfono</mat-label>
                    <input matInput formControlName="telefono" placeholder="Ej: +54 11 1234-5678">
                </mat-form-field>

                <div class="form-radio-line" *ngIf="editMode">
                    <span class="radio-line-label">Estado</span>
                    <div class="radios">
                        <mat-radio-group formControlName="activo">
                            <mat-radio-button [value]="true">Activo</mat-radio-button>
                            <mat-radio-button [value]="false">Inactivo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ editMode ? 'Guardar cambios' : 'Crear comercial' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</app-nav>
